export default "__VITE_ASSET__4ce4e3a9__"